export class TblEMailTemplate
{
    refNo:number
    templateId:string;
    templateName:string;
    templateDetails:string;
    active:string;
    fileAllowed:string;
    subject:string
}